import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const steps = [
  { n: "01", title: "Nominate", body: "Any member can nominate a shop, café, workplace or attraction they want reviewed for accessibility." },
  { n: "02", title: "Inspect", body: "Our trained inspectors visit and complete a category-specific grading form — draft it, save it, return later." },
  { n: "03", title: "Publish", body: "Once submitted, the venue appears on the map with its rating, features and contact details for everyone to use." },
  { n: "04", title: "Improve", body: "Owners can respond and community feedback keeps profiles accurate as venues update." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-gray-900">How it works</h1>
      <p className="mt-4 text-lg text-gray-700 max-w-2xl">Access Local is a partnership between members and inspectors, powered by a consistent grading framework.</p>
      <div className="mt-10 grid gap-6 md:grid-cols-2">
        {steps.map(s => (
          <div key={s.n} className="border-2 border-gray-900 rounded-xl bg-white p-6">
            <div className="font-heading text-5xl font-bold text-blue-600">{s.n}</div>
            <h3 className="mt-2 font-heading text-2xl font-semibold text-gray-900">{s.title}</h3>
            <p className="mt-2 text-gray-700 leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 flex flex-wrap gap-3">
        <Button asChild className="rounded-full bg-blue-600 hover:bg-blue-700 h-12 px-6"><Link to="/register">Get involved</Link></Button>
        <Button asChild variant="outline" className="rounded-full border-2 border-gray-900 h-12 px-6"><Link to="/search">Browse venues</Link></Button>
      </div>
    </div>
  );
}
